module.exports = "https://cdn-assessment.mathletics.com/app/119/assets/images/11d32419f8bc0e3125928a6587f5d1fa.svg";